export default __webpack_public_path__ + "static/media/r5.8eb7183a.jpg";